import { atomWithDebounce } from '@rematter/ui-web';
import type { Atom } from 'jotai';
import { atom } from 'jotai';

import { createItemJurisdictionCodeMutationAtom } from '../_graphql/mutationItemJurisdictionCodeCreate';
import { deleteItemJurisdictionCodeMutationAtom } from '../_graphql/mutationItemJurisdictionCodeDelete';
import { updateItemJurisdictionCodeMutationAtom } from '../_graphql/mutationItemJurisdictionCodeUpdate';
import type { ComplianceItemJurisdictionCodeRecord } from '../_graphql/queryComplianceItemJurisdictionCodes';
import { queryComplianceItemJurisdictionCodesAtom } from '../_graphql/queryComplianceItemJurisdictionCodes';

import type { QueryAtomReadValue } from '~/shared/providers/api/createQueryAtomFactory';

export const $itemCodesSearchTerm = atomWithDebounce('', 300);
export const $isItemCodeDialogOpen = atom(false);
export const $editingItemCode = atom<string | null>(null);

export const $rawItemJurisdictionCodes =
  queryComplianceItemJurisdictionCodesAtom(() => ({}));

export const $itemJurisdictionCodes: Atom<
  QueryAtomReadValue<ComplianceItemJurisdictionCodeRecord[]>
> = atom((get) => {
  const raw = get($rawItemJurisdictionCodes);
  const searchTerms = get($itemCodesSearchTerm.debouncedValue)
    .toLowerCase()
    .split(/\s+/)
    .filter(Boolean);

  const data = (raw.data ?? []).filter((entry) => {
    if (searchTerms.length === 0) return true;
    const searchable = [entry.itemName, entry.serviceType, entry.code]
      .filter(Boolean)
      .join(' ')
      .toLowerCase();
    return searchTerms.every((term) => searchable.includes(term));
  });

  return { ...raw, data };
});

export const $createItemJurisdictionCode =
  createItemJurisdictionCodeMutationAtom({
    onSuccess: (get) => {
      get($rawItemJurisdictionCodes).refetch?.();
    },
  });

export const $updateItemJurisdictionCode =
  updateItemJurisdictionCodeMutationAtom({
    onSuccess: (get) => {
      get($rawItemJurisdictionCodes).refetch?.();
    },
  });

export const $deleteItemJurisdictionCode =
  deleteItemJurisdictionCodeMutationAtom({
    onSuccess: (get) => {
      get($rawItemJurisdictionCodes).refetch?.();
    },
  });
